import { createFileRoute } from "@tanstack/react-router";
import {
	type OutreachHubFilters,
	parseHubFilters,
} from "@/components/outreach/hub-filters";
import { PhoneCampaignDetail } from "@/components/phone-banking/PhoneCampaignDetail";

export const Route = createFileRoute(
	"/_app/_/contacts/phone-banking/$campaignId",
)({
	// `from=outreach` is set when this legacy campaign is opened from the
	// Outreach hub, so its back control returns to /outreach (carrying the hub
	// filters) instead of browser history (which, from the contacts list, would
	// be /contacts).
	validateSearch: (
		search: Record<string, unknown>,
	): { from?: "outreach" } & OutreachHubFilters => ({
		from: search.from === "outreach" ? "outreach" : undefined,
		...parseHubFilters(search),
	}),
	component: PhoneBankingContactDetailPage,
});

function PhoneBankingContactDetailPage() {
	const { campaignId } = Route.useParams();
	const { from, ...filters } = Route.useSearch();
	return (
		<PhoneCampaignDetail
			phoneCampaignId={Number(campaignId)}
			backTo={from === "outreach" ? "/outreach" : undefined}
			backSearch={filters}
		/>
	);
}
